import { useToast } from '@repo/design-system/index'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import PortalContainer from '../../../../../components/container/PortalContainer'
import SelectMaterialCard, {
  SelectMaterialCardSkeleton,
} from '../../../../../components/new-portal/lessons/materials/SelectMaterialCard'
import { useEventTracking } from '../../../../../helpers/gtmHelper'
import { useExperiencedMaterials } from '../../../../../modules/apis/student/material/queries'
import { APP_SCREEN_NAME } from '../../../../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../../../../modules/hooks/common/useAppRouter'
import useIsMobile from '../../../../../modules/hooks/common/useIsMobile'
import { useOnclickHeartPacket } from '../../../../../modules/hooks/common/useOnclickHeartPacket'
import useReturnFullUrl from '../../../../../modules/hooks/webview/common/useReturnFullUrl'
import { n_material } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import urls from '../../../../../modules/urls'

export const ExperiencedMaterials = () => {
  const isMobile = useIsMobile(null, 640)
  const { t, isLocaleKO } = useTranslation()
  const { toastSuccess } = useToast()
  const { sendClickEvent } = useEventTracking()
  const router = useAppRouter()
  const getFullUrl = useReturnFullUrl()

  const { data: materialsData, isFetching: materialsFetching } = useExperiencedMaterials()

  const [selectedHashId, setSelectedHashId] = useState('전체')
  const [materialList, setMaterialList] = useState([])

  const titleTranslations = (data) => [
    data.title_kr,
    data.title_en,
    '',
    data.title_en,
    data.title_en,
    data.title_en,
    data.title_en,
  ]

  useEffect(() => {
    if (materialsData && !materialsFetching) {
      const filteredCourseList = selectedHashId
        ? materialsData.small_hashtags
            .filter((hash) => hash.title_kr == selectedHashId)
            .flatMap((hash) => hash.courses) || []
        : materialsData.small_hashtags[0]?.courses
      setMaterialList(filteredCourseList)
    }
  }, [materialsData, materialsFetching, selectedHashId])

  const onClickHeartPacket = useOnclickHeartPacket({
    packetItems: materialList,
    setPacketItems: setMaterialList,
    isList: true,
    onAdded: () => toastSuccess(t(n_material.toast_book_mark)),
    onDeleted: () => toastSuccess(t(n_material.toast_delete_book_mark)),
  })

  return (
    <div className={classNames('mt-[20px] flex flex-col px-[16px] sm:mt-[40px]')}>
      {materialsData && !materialsFetching ? (
        <div className="Headline2-24Bd">
          {t(titleTranslations(materialsData))} ({materialsData.small_hashtags[0].courses.length})
        </div>
      ) : (
        <div className="h-[34px] w-[240px] rounded-[4px] bg-gray-100"></div>
      )}
      <div className="mt-[16px] flex flex-wrap gap-[8px] border-gray-300 font-medium">
        {materialsData && !materialsFetching ? (
          materialsData?.small_hashtags.map((hash, i) => {
            return (
              <button
                key={i}
                onClick={() => setSelectedHashId(hash.title_kr)}
                className={classNames(
                  selectedHashId === hash.title_kr &&
                    'border-purple-500 bg-purple-50 text-[16px] font-bold text-purple-500',
                  'rounded-[8px] border-[1.5px] px-[16px] py-[8px] text-[16px] '
                )}
              >
                {isLocaleKO ? hash.title_kr : hash.title_en}
              </button>
            )
          })
        ) : (
          <div className="flex flex-row gap-[16px]">
            <button className={'h-[42px] w-[64px] rounded-[8px]  bg-gray-100 px-[16px] py-[8px] text-[16px]'}></button>
            <button className={'h-[42px] w-[64px] rounded-[8px] bg-gray-100 px-[16px] py-[8px] text-[16px]'}></button>
          </div>
        )}
      </div>
      <div>
        {!materialsFetching && materialList?.length > 0 ? (
          <div
            className={classNames(
              'mt-[36px] grid grid-cols-1 gap-y-[10px] sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'
            )}
          >
            {materialList?.map((material) => {
              return (
                <div
                  onClick={() => {
                    sendClickEvent({ button_name: 'material_card', object_id: material.id })
                    router.push(urls.student.newPortal.materials.detail(material.id), {
                      appScreenName: APP_SCREEN_NAME.STACK_SCREEN,
                      appSendData: { url: getFullUrl(urls.webview.materials.detail(material.id)) },
                    })
                  }}
                  key={material.id}
                >
                  <SelectMaterialCard
                    isList={true}
                    horizontal={isMobile}
                    title={material.title}
                    subtitle={material.subtitle}
                    is_mine={material.is_mine}
                    category={material.category}
                    image_url={material.image_url}
                    is_revised={material.is_revised}
                    is_today={material.is_today}
                    onClickHeart={(e) => {
                      onClickHeartPacket(e, material)
                    }}
                    level={material.level}
                    audioLength={material.mp3_running_time_in_minute}
                  />
                </div>
              )
            })}
          </div>
        ) : (
          <div className="w-full">
            <div className="mb-[32px] mt-[36px] w-full">
              <section className="">
                <div
                  className={classNames(
                    'flex w-full flex-col gap-[9px] sm:grid sm:grid-cols-2 sm:flex-row md:grid-cols-3 lg:grid-cols-4'
                  )}
                >
                  {[0, 1, 2, 3, 4, 5, 6, 7].map((_, i) => (
                    <div className="w-full" key={i}>
                      <SelectMaterialCardSkeleton horizontal={isMobile} />
                    </div>
                  ))}
                </div>
              </section>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
const Index = () => {
  const { t } = useTranslation()
  return (
    <PortalContainer backTo={urls.student.newPortal.myRingle.index}>
      <ExperiencedMaterials />
    </PortalContainer>
  )
}

export default Index
